import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function InstagramCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    if (code) {
      // Forward the authorization code to the backend
      window.location.href = `${API_URL}/api/instagram/callback?code=${encodeURIComponent(code)}`;
    } else {
      // No code — redirect to admin with error
      window.location.href = `${window.location.origin}/admin?ig_error=no_code`;
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-warm-white flex items-center justify-center" data-testid="ig-callback">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-charcoal font-medium">Connecting Instagram...</p>
      </div>
    </div>
  );
}

export default InstagramCallback;
